import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Pipe({
  name: 'prodTypeInstType'
})
export class ProdTypeInstTypePipe implements PipeTransform {

  constructor(private db: AngularFirestore) {}

  transform(value: any): any {
    return this.db.collection('productTypeInstitutionType', detail => detail.where('fkInstitutionType', '==', value.id)).valueChanges();
  }

}
